import type { QueryParamValuesSetter } from "@octopusdeploy/portal-routes";
import { useMemo } from "react";
import type { RunbooksPageQueryParams } from "../RunbooksPage";
export interface RunbooksFilterState {
    filterByName?: string;
    filterByTags: string[];
}
export function useRunbooksFilterState(queryParams: RunbooksPageQueryParams, setQueryParams: QueryParamValuesSetter<RunbooksPageQueryParams>, localFilterByName?: string): [
    RunbooksFilterState,
    (filter: RunbooksFilterState) => void
] {
    function setRunbooksFilterState(filter: RunbooksFilterState) {
        setQueryParams({
            runbookTags: filter.filterByTags.length > 0 ? filter.filterByTags : undefined,
        });
    }
    const runbooksFilterState = useMemo((): RunbooksFilterState => ({
        filterByName: localFilterByName,
        filterByTags: queryParams.runbookTags || [],
    }), [queryParams.runbookTags, localFilterByName]);
    return [runbooksFilterState, setRunbooksFilterState];
}
